import './styles/Wrapper.css';
import './styles/Cards.css';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { memo, Suspense, } from 'react';
import { Carousel } from 'react-responsive-carousel';
import { useTranslation } from "react-i18next";

import { carouselSlides } from './content/carousel';

import { Header } from './Header';
import { ContentText } from './ContentText';
import { Rules } from './Rules';
import { Larps } from './Larps';
import { Gallery } from './Gallery';
import { Characters } from './Characters';
import { Contacts } from './Contacts';
import { Footer } from './Footer';

export const Wrapper = memo(() => {
  const { t } = useTranslation();
  const aboutUs = t("aboutUs", { returnObjects: true }) || {};
  const aboutUsSecond = t("aboutUsSecond", { returnObjects: true }) || {};
  const howTo = t("howWeWork", { returnObjects: true }) || {};
  return (
    <div className="wrapper">
      <Header />
      <Suspense fallback={<div>loading...</div>}>
        <Carousel className="main-carousel" autoPlay infiniteLoop emulateTouch swipeable showThumbs={false}>
          {carouselSlides.map(slide => 
            <img src={slide} alt="Złote Lwy Marienburga"/>
          )}
        </Carousel>
      </Suspense>
      <div id="o-nas">
        <ContentText
          title={aboutUs.title}
          text={aboutUs.text}
          img={aboutUs.img}
        />
        <ContentText
          text={aboutUsSecond.text}
          img={aboutUsSecond.img}
          textRightSide={true}
        />
      </div>
      <div id="wartości">
        <Rules />
      </div>
      <div id="dzialamy">
        <ContentText
          title={howTo.title}
          text={howTo.text}
          img={howTo.img}
          textRightSide={true}
        />
      </div>
      <div id="larps">
        <Larps />
      </div>
      <div id="galeria">
        <Gallery />
      </div>
      <div id="postacie">
        <Characters />
      </div>
      <div id="linki">
        <Contacts />
      </div>
      <Footer />
    </div>
  );
});

export default Wrapper;
